import axios from "axios";

const state = {
  transactions: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null
  }
};

const actions = {
  async fetchTransactions({ commit, dispatch }, params) {
    dispatch('loading/showLoading', null, { root: true });

    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/transactions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: params
      });
      const data = response.data;
      commit("SET_TRANSACTIONS", data.data);
      commit('SET_PAGINATION', data.pagination);
    }
    catch (error) {
      console.error("Error fetching transactions:", error);
    }
    finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },  
  async fetchTransactionByCustomerId({ commit }, customer_id) {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/transactions?customer_id=${customer_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      
      return response.data;
    }
    catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn(`No transactions found for customer ID: ${customer_id}`);
        return [];
      }
      console.error('Failed to fetch transaction by customer ID:', error);
      throw error;
    }
  },
  createTransaction({commit}, transaction) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('auth_token');
      axios.post(`${process.env.VUE_APP_ROOT_API}/transactions`, transaction, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        const data = response.data;
        commit('ADD_TRANSACTION', data);
        resolve(data);
      })
      .catch(error => {
        console.error('Failed to create transaction', error);
        reject(error);
      });
    });
  },
  async deleteTransactionById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('auth_token');
      axios.delete(`${process.env.VUE_APP_ROOT_API}/transactions/${id}`, {
        headers: {
        'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        commit('REMOVE_TRANSACTION', id);
        resolve(response.data);
      })
      .catch(error => {
        console.error('Failed to delete transaction', error);
        reject(error);
      });
    });
  }
};

const mutations = {
  SET_TRANSACTIONS(state, transactions) {
    if (transactions && Array.isArray(transactions)) {
      state.transactions = transactions;
    } else {
      state.transactions = [];
    }
  },
  ADD_TRANSACTION(state, transaction) {
    state.transactions.push(transaction);
  },
  REMOVE_TRANSACTION(state, id) {
    state.transactions = state.transactions.filter(product => product.id !== id);
  },
  SET_PAGINATION(state, pagination) {
    state.pagination.page = pagination.page || 1;
    state.pagination.perPage = pagination.perPage || 10;
    state.pagination.totalItems = pagination.totalItems || 0;

    state.pagination.previousPageLink = pagination.previousPageLink ? pagination.previousPageLink.replace(/\/api\/v1\/transactions\?/, '') : null;
    state.pagination.nextPageLink = pagination.nextPageLink ? pagination.nextPageLink.replace(/\/api\/v1\/transactions\?/, '') : null;
  },
};

const getters = {
  allTransactions: (state) => state.transactions,
  pagination: (state) => state.pagination
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
